import React, { ReactElement } from 'react'
import { FieldErrors, RegisterOptions, UseFormRegister } from 'react-hook-form'
import ReactTooltip from 'react-tooltip'

const Component = (props: {
  name: string,
  id: string;
  value?: string | number;
  defaultChecked?: boolean;
  label?: string;
  info?: string
  className?: string;
  disabled?: boolean;
  errors?: FieldErrors;
  register: UseFormRegister<any>;
  validations?: RegisterOptions<any>;
}): ReactElement => {
  const {
    name,
    id,
    value,
    defaultChecked,
    label,
    info,
    className,
    disabled,
    errors,
    register,
    validations
  } = props

  const classes = [
    'form-item',
    'form-item--radio',
    'relative',
    'reduce-bottom-spaces',
    info
      ? 'form-group--with-info'
      : '',
    errors && errors[id]
      ? 'error'
      : ''
  ]
    .filter(Boolean)
    .join(' ')

  let required = false
  if (validations) {
    required = Object.keys(validations).filter(key => key === 'required').length > 0
  }

  return (
    <div className={`react-form__form-group ${className || ''}`}>
      <div className={classes}>
        <div>
          <input
            type="radio"
            id={id}
            value={value || id}
            className="form-radio"
            defaultChecked={defaultChecked}
            {...register(name, validations)}
            disabled={disabled}
          />
          {label && (
            <div className="inline-flex gap-1">
              <label
                htmlFor={id}
                className={required ? 'form-required text-lg' : 'text-lg'}
              >
                {label}
              </label>
              {info && (
                <>
                  <span>
                    <i
                      className="info-icon"
                      data-tip
                      data-for={id}
                      data-place="bottom"
                      data-event="click focus"
                    />
                  </span>
                  <ReactTooltip
                    id={id}
                    effect="solid"
                    globalEventOff="click"
                  >
                    <div className="form-group__info absolute active">
                      {info}
                    </div>
                  </ReactTooltip>
                </>
              )}
            </div>
          )}
        </div>
        {errors && errors[id] &&
          <div className="mt-2 text-sm form-item--error-message">
            {errors[id]?.message}
          </div>
        }
      </div>
    </div>
  )
}

export default Component
